import { createSlice }  from '@reduxjs/toolkit';

export const languageSlice = createSlice({
    name:'languageSlice',
    initialState:{
        language: "english"
    },
    reducers:{
        setLanguageEnglish: (state) => {state.language = 'english'},
        setLanguageUrdu: (state) => {state.language = 'urdu'},
    }
});

export const {setLanguageEnglish, setLanguageUrdu} = languageSlice.actions;

export const currentLanguage = (state) => {return(state.languageSlice.language)};

export default languageSlice.reducer